"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _digiwashComponents = require("digiwash-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BoxRatio(props) {
  let [w, h] = props.ratio.split(":");
  let width = 100; // percent

  let height = h * 100 / w;
  return /*#__PURE__*/_react.default.createElement(_digiwashComponents.Box, {
    br: "m",
    style: {
      width: `${width}%`,
      paddingTop: `${height}%`,
      position: "relative",
      overflow: "hidden"
    }
  }, /*#__PURE__*/_react.default.createElement(_digiwashComponents.Box, {
    style: {
      width: "100%",
      height: "100%",
      position: "absolute",
      top: 0,
      left: 0
    }
  }, props.children));
}

var _default = BoxRatio;
exports.default = _default;